const { SimpleSocket } = await import("uidispatcher_api/UidispatcherApiModule");
export default SimpleSocket;
